import React, { Component } from 'react';
import logoHeader from '../../static/images/logo-header.svg';

export default class Header extends Component {
  render() {
    return (
      <header>
        <a href="/" className="logo">
          <img src={logoHeader} alt="Rabbit logo"/>
        </a>
            {
              (this.props.listLocale) ?
                (
                  <div>
                    <ul>
                  {
                    (this.props.listLocale || []).map(item => {
                      return item === this.props.currentLocale ? '' : (
                        <li key={item} onClick={() => this.props.changeLocale(item)}>
                          <this.props.T.text tag="span" text={"locale." + item}/>
                        </li>
                      )
                    })
                  }
                    </ul>
                  </div>
                ) : ''
            }
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/header.js